import type { CSSProperties } from 'react'
import type { LucideIcon } from 'lucide-react'
import { blockTheme, hsl } from '@teach/ui'
import type { DesignElementType } from '@/types/blocks'
import { setHoveredDesignElement } from '@/features/editor/lib/designHoverPreview'

interface Props {
  type: DesignElementType
  label: string
  icon: LucideIcon
  onAdd: (type: DesignElementType) => void
}

/** Чип типа элемента на холсте составного блока: наведение — примерка
 *  (`designHoverPreview`) и подсветка акцентом, клик — добавить элемент. Примерку
 *  снимает уход мыши из всего ряда (`DesignAddElement`), закрытие или добавление. */
export const ElementTypeChip = ({ type, label, icon: Icon, onAdd }: Props) => (
  <button
    type="button"
    onMouseEnter={() => setHoveredDesignElement(type)}
    onClick={() => {
      setHoveredDesignElement(null)
      onAdd(type)
    }}
    // CSS-переменные: цвета из blockTheme, hover-класс Tailwind сам их не знает.
    className="flex items-center gap-1 rounded-full bg-[var(--chip-bg)] px-2.5 py-1.5 text-xs font-semibold text-[var(--chip-fg)] transition hover:scale-105 hover:bg-[var(--chip-bg-hover)] hover:text-[var(--chip-fg-hover)]"
    style={
      {
        '--chip-bg': hsl(blockTheme.foreground, 0.08),
        '--chip-fg': hsl(blockTheme.foreground, 0.9),
        '--chip-bg-hover': hsl(blockTheme.primary, 0.15),
        '--chip-fg-hover': hsl(blockTheme.primary),
      } as CSSProperties
    }
  >
    <Icon className="size-3.5" />
    {label}
  </button>
)
